module.exports = "/_next/static/images/epn_4-7d6cf0df412a46fb41167d3b80bba7ec.jpeg";